import {Routes} from "@angular/router";
import {WorkflowPartnerOneUpgradeSlaComponent} from "./workflow-partner-one-upgrade-sla.component";

export const workflowPartnerOneUpgradeSlaRouting: Routes = [
    { path: 'partner/upgrade-sla/:aid', component: WorkflowPartnerOneUpgradeSlaComponent, children: [
        { path: 'contact', component: WorkflowPartnerOneUpgradeSlaComponent },
        { path: 'address', component: WorkflowPartnerOneUpgradeSlaComponent },
        { path: 'payment', component: WorkflowPartnerOneUpgradeSlaComponent },
        { path: 'checkout', component: WorkflowPartnerOneUpgradeSlaComponent },
        { path: 'complete', component: WorkflowPartnerOneUpgradeSlaComponent },
        { path: '', redirectTo: 'contact', pathMatch: 'full' },
    ]},
]
